module.exports = __webpack_public_path__ + "static/img/Employee-RGH-LEFT.0fcfb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/whoweare/Employee-RGH-LEFT.jpg
// module id = cKJz
// module chunks = 1